export const filter = {
    id: "",
    name: "",
    // file: "",
    category_id: null,
    search: "",
    created_at: "",
    updated_at: "",
};
